import { useLocalStorage } from '@root/hooks'
import { parseUTM, UTMParams } from './parseUTM'
import { isEmpty, isEqual } from 'lodash'
import { useEffect, useMemo } from 'react'
import { omitEmptyValues } from './omitEmptyValues'

const UTM_LOCAL_STORAGE_KEY = 'utm'

export const useStoreUTM = () => {
  const parsed = useMemo<UTMParams>(() => {
    if (typeof window === 'undefined') return {}
    return parseUTM(window.location.href)
  }, [])
  const [stored, setStored] = useLocalStorage<UTMParams>(UTM_LOCAL_STORAGE_KEY, parsed)
  useEffect(() => {
    if (isEmpty(parsed) || isEqual(parsed, stored)) return
    setStored(stored => {
      const parsed_ = omitEmptyValues(parsed)
      if (!isEmpty(parsed_)) {
        const updated = { ...stored, ...parsed_ }
        console.info('Storing UTM parameters:', updated)
        return updated
      }
      return stored
    })
  }, [parsed, stored, setStored])
}

export const useUTM = () => {
  const [stored, setStored] = useLocalStorage<UTMParams>(UTM_LOCAL_STORAGE_KEY, {})

  const clear = () => {
    setStored({})
  }

  return { stored, clear }
}
